import React from 'react';
import { useAuth } from '../../context/AuthContext';
import colors from '../../theme/colors';

const styles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 24px',
    borderBottom: `1px solid ${colors.cardBorder}`,
    background: colors.card,
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  logoImg: {
    height: 28,
  },
  logoText: {
    color: colors.accent,
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: '0.5px',
  },
  badge: {
    background: colors.surface,
    color: colors.accent,
    padding: '3px 10px',
    borderRadius: 10,
    fontSize: 12,
    fontFamily: 'monospace',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  time: {
    color: colors.textDim,
    fontSize: 12,
  },
  logout: {
    background: 'none',
    border: `1px solid ${colors.cardBorder}`,
    color: colors.textMuted,
    padding: '4px 14px',
    borderRadius: 6,
    fontSize: 12,
    cursor: 'pointer',
  },
};

export default function Header({ lastUpdate }) {
  const { logout } = useAuth();

  return (
    <header style={styles.header}>
      <div style={styles.left}>
        <img src="/logo-full.png" alt="Smartville" style={styles.logoImg} />
        <span style={styles.logoText}>SV360</span>
        <span style={styles.badge}>iot-sensor-001</span>
      </div>
      <div style={styles.right}>
        {lastUpdate && (
          <span style={styles.time}>
            {new Date(lastUpdate).toLocaleTimeString()}
          </span>
        )}
        <button style={styles.logout} onClick={logout}>Logout</button>
      </div>
    </header>
  );
}
